import { useCollectPaymentMultiContext } from '../../../collect-payment-multi.context';
import { useTerminalStepStripeContext } from '../../terminals/terminal-step-context/terminal-step-context-stripe';
import { useTerminalReadersQuery } from '../../terminals/use-terminal-readers-query';
import { CollectTerminalNavigationSwitch } from './collect-terminal-navigation-switch';
import { CollectTerminalStep } from './collect-terminal-step';
import { CollectTerminalStepBodyProps } from './collect-terminal.types';

export const CollectTerminalStripe = () => {
  return <CollectTerminalNavigationSwitch body={CollectTerminalStripeBody} />;
};

const CollectTerminalStripeBody = ({
  onGoBack,
  onCloseWithoutReceipt,
  onInvoiceSent,
  onPaymentSuccess,
}: CollectTerminalStepBodyProps) => {
  const {
    activeLocationId,
    invoice,
    stripeData: { stripeLocationId },
  } = useCollectPaymentMultiContext();

  const { selectedReader, setSelectedReader, tempReader, setTempReader } = useTerminalStepStripeContext();

  const locationId = invoice?.locationId || activeLocationId;

  const {
    readers,
    refetchReadersAsync,
    isLoading: isReadersLoading,
  } = useTerminalReadersQuery({
    locationId,
    stripeLocationId,
  });

  return (
    <CollectTerminalStep
      readers={readers}
      selectedReader={selectedReader}
      isReadersLoading={isReadersLoading}
      onGoBack={onGoBack}
      onInvoiceSent={onInvoiceSent}
      refetchReaders={refetchReadersAsync}
      onPaymentSuccess={onPaymentSuccess}
      setSelectedReader={setSelectedReader}
      tempReader={tempReader}
      setTempReader={setTempReader}
      onCloseWithoutReceipt={onCloseWithoutReceipt}
    />
  );
};
